import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/articles";

export default function CategorySection() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-editorial px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="按你想看的方向找"
          desc="六个固定栏目，分别对应不同的观察角度，互不重叠。"
        />
        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/insights?category=${cat.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-50 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600">
                  <i className={`${cat.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="text-xs text-foreground-400">{cat.count} 篇</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                {cat.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-foreground-500 transition-colors group-hover:text-primary-600">
                进入栏目
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}